















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: {
    ...mapGetters({
        Lang: 'lang'
    })
  }
})
export default class LangButton extends Vue {
    private Languages = [
        {
            Title: 'Français',
            Flag: 'fr',
            File: 'fr'
        },
        {
            Title: 'English',
            Flag: 'usa',
            File: 'en'
        }
    ];

    changeLang(lang: string) : void {
        this.$store.commit('CHANGE_LANG', lang);
    }
}
